import * as RadixAccordion from '@radix-ui/react-accordion';
import { AccordionGroupProps } from './AccordionGroup.types';

export const AccordionGroup = (props: AccordionGroupProps) => (
  <RadixAccordion.Root {...props} />
);
